<template>
  <PricesVerticalV2
    :is-loading="isLoading"
    :title="title"
    :period="period"
    :button-text="buttonText"
    :button-text-free-trial="buttonTextFreeTrial"
    :price-description="priceDescription"
    :primary-color="primaryColor"
    :secondary-color="secondaryColor"
    :terciary-color="terciaryColor"
    :quaternary-color="quaternaryColor"
    :quinary-color="quinaryColor"
    :senary-color="senaryColor"
    :septenary-color="septenaryColor"
    :octonary-color="octonaryColor"
    :nonary-color="nonaryColor"
    :decenary-color="decenaryColor"
    :undenary-color="undenaryColor"
    :plan-highlight-text="planHighlightText"
    :background-image-url="backgroundImageUrl"
    :prices="prices"
    @subscribe="({ price }) => $emit('subscribe', { price })"
  >
    <template #switcher>
      <Switcher
        :left-text="leftSwitchText"
        :right-text="rightSwitchText"
        :switch-on-annual="showSecondPlanArea"
        :annual-discount="annualSwitchDiscount"
        @switch="(isRight) => (showSecondPlanArea = isRight)"
      />
    </template>
  </PricesVerticalV2>
</template>
<script>
export default {
  components: {
    PricesVerticalV2: () => import('@/components/Prices/PricesVerticalV2'),
    Switcher: () => import('@/components/Prices/PricesVerticalWithSwitchV2/Switcher.vue')
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    title: {
      type: Array,
      required: true
    },
    primaryColor: {
      type: String,
      default: ''
    },
    secondaryColor: {
      type: String,
      default: ''
    },
    terciaryColor: {
      type: String,
      default: ''
    },
    quaternaryColor: {
      type: String,
      default: ''
    },
    quinaryColor: {
      type: String,
      default: ''
    },
    senaryColor: {
      type: String,
      default: ''
    },
    septenaryColor: {
      type: String,
      default: ''
    },
    octonaryColor: {
      type: String,
      default: ''
    },
    nonaryColor: {
      type: String,
      default: ''
    },
    decenaryColor: {
      type: String,
      default: ''
    },
    undenaryColor: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      required: true
    },
    leftSwitchText: {
      type: String,
      required: true
    },
    rightSwitchText: {
      type: String,
      required: true
    },
    annualSwitchDiscount: {
      type: String,
      default: ''
    },
    firstPlanAreaPrices: {
      type: Array,
      required: true
    },
    secondPlanAreaPrices: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    },
    priceDescription: {
      type: String,
      required: true
    },
    buttonTextFreeTrial: {
      type: String,
      required: true
    },
    planHighlightText: {
      type: String,
      required: true
    },
    backgroundImageUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showSecondPlanArea: true
    };
  },
  computed: {
    prices() {
      return this.showSecondPlanArea ? this.secondPlanAreaPrices : this.firstPlanAreaPrices;
    }
  }
};
</script>
